<template>
<div class="chapter">
<div class="inner_page">
<div id="Frontmatter">
<p class="fig-img"><img alt="" class="image" src="images/ufig_1.jpg"/></p>
<p class="fig-caption">This Iraqi BMD-1 was destroyed in 2003 during Operation Iraqi Freedom. Iraq was only supplied a small number of these vehicles.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Frontmatter.vue?32a91fe1